export const filterGridData =
    (
        filters: {
            id?: number | string;
            field: string;
            value?: any;
            /**
             * | "contains"
             * | "does not contain"
             * | "equals"
             * | "does not equal"
             * | "starts with"
             * | "ends with"
             * | "is empty"
             * | "is not empty"
             * | "is any of";
             */
            operator: string;
        }[]
    ) =>
    (item: any): boolean => {
        return filters.every((filter) => {
            const fieldValue = item[filter.field];
            const value = filter.value;

            switch (filter.operator) {
                case "contains":
                    return fieldValue
                        ?.toString()
                        .toLowerCase()
                        .includes((value as string).toLowerCase());

                case "does not contain":
                    return !fieldValue
                        ?.toString()
                        .toLowerCase()
                        .includes((value as string).toLowerCase());

                case "equals":
                    return fieldValue?.toString().toLowerCase() === (value as string).toLowerCase();

                case "does not equal":
                    return fieldValue?.toString().toLowerCase() !== (value as string).toLowerCase();

                case "starts with":
                    return fieldValue
                        ?.toString()
                        .toLowerCase()
                        .startsWith((value as string).toLowerCase());

                case "ends with":
                    return fieldValue
                        ?.toString()
                        .toLowerCase()
                        .endsWith((value as string).toLowerCase());

                case "is empty":
                    return fieldValue === "" || fieldValue === null || fieldValue === undefined;

                case "is not empty":
                    return fieldValue !== "" && fieldValue !== null && fieldValue !== undefined;

                case "is any of":
                    if (!Array.isArray(value)) return false;
                    return value.map((v) => v.toLowerCase()).includes(fieldValue?.toString().toLowerCase());

                default:
                    return true; // Unknown operator, do not filter out
            }
        });
    };
